import { Box, Button, SpaceBetween } from '@amzn/awsui-components-console';
import { useNavigate } from 'react-router-dom';

import { paths } from '@/routing/paths';

import { messages } from './index.messages';

import type { FooterProps } from './types';

export const Footer: React.FC<FooterProps> = ({
    requiresSubProvider,
    onCloseStudentListModal,
    addStudentsToRosterHandler,
    classCapacitySizeExceededBy,
    capacityUpdateWithRoster,
    gilmoreLicenseError,
    thereIsActiveEvent,
    showBtnSpinner,
    resetOverCapacityAndLicenseError,
    formatMessage,
    classroomId,
    providersMap,
    classCapacityHasExceeded,
}) => {
    const navigate = useNavigate();

    const renderContent = () => {
        if (gilmoreLicenseError) {
            return (
                <>
                    <Button
                        href='https://aws.gilmoreglobal.com/login'
                        iconAlign='left'
                        iconName='external'
                        target='_blank'
                        variant='link'
                    >
                        {formatMessage(messages.gilmoreLicenseStoreFrontLink)}
                    </Button>
                    <Button onClick={resetOverCapacityAndLicenseError} variant='primary'>
                        {formatMessage(messages.editStudentListButton)}
                    </Button>
                </>
            );
        }

        if (classCapacitySizeExceededBy > 0) {
            return (
                <>
                    <Button onClick={resetOverCapacityAndLicenseError} variant='link'>
                        {formatMessage(messages.editStudentListButton)}
                    </Button>
                    {requiresSubProvider ? (
                        <Button
                            onClick={() => {
                                const params = new URLSearchParams();
                                params.set('openStudentListModal', 'true');
                                params.set('providersMap', JSON.stringify(providersMap));
                                params.set('classroomId', classroomId);
                                navigate(
                                    `${paths.classEditPage(classroomId)}?${params.toString()}`,
                                );
                            }}
                            loading={showBtnSpinner}
                            disabled={thereIsActiveEvent}
                            variant='primary'
                        >
                            {formatMessage(messages.goToEditClass)}
                        </Button>
                    ) : (
                        <Button
                            onClick={capacityUpdateWithRoster}
                            loading={showBtnSpinner}
                            disabled={thereIsActiveEvent}
                            variant='primary'
                        >
                            {formatMessage(messages.updateClassCapacity)}
                        </Button>
                    )}
                </>
            );
        }

        return (
            <>
                <Button onClick={onCloseStudentListModal} variant='normal'>
                    {formatMessage(messages.closeModalButtonText)}
                </Button>
                <Button
                    onClick={addStudentsToRosterHandler}
                    loading={showBtnSpinner}
                    variant='primary'
                    disabled={classCapacityHasExceeded}
                >
                    {formatMessage(messages.addListModalButtonText)}
                </Button>
            </>
        );
    };

    return (
        <Box float='right' data-testid='student-roster-modal-footer'>
            <SpaceBetween direction='horizontal' size='xs'>
                {renderContent()}
            </SpaceBetween>
        </Box>
    );
};
